<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/gallery-toggle.svg" size="2"></app-svg>
  <h1>Custom Preset</h1>
  @if (customPresets?.length) {
    <div class="change-mode">
      <div class="fake-radio" [class.active]="mode === 'override'" (click)="mode = 'override'">Update Existing</div>
      <div class="fake-radio" [class.active]="mode === 'new'" (click)="mode = 'new'">Create New</div>
    </div>
  }
  @if (mode === 'new') {
    <form [formGroup]="newPresetForm" #ngForm="ngForm" [class.submitted]="ngForm.submitted" (ngSubmit)="savePreset()">
      <app-input-field [control]="newPresetForm.controls.name">
        <input type="text" formControlName="name" data-test-id="create-preset-input" appAutofocus />
        <label>Preset Name</label>
      </app-input-field>
      <button
        appButton
        name="confirm-create"
        location="save-gallery-prset-dialog"
        data-test-id="create-preset-confirm"
        color="primary"
        height="3"
        class="cta"
        shape="round"
        size="3"
        weight="bold"
        spacing="full"
      >
        <span [class.hidden-text]="loading">Create Preset</span>
        @if (loading) {
          <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
        }
      </button>
    </form>
  }
  @if (mode === 'override') {
    <form
      [formGroup]="overridePresetForm"
      #ngForm="ngForm"
      [class.submitted]="ngForm.submitted"
      (ngSubmit)="savePreset()"
    >
      @if (customPresets) {
        <app-input-field [control]="overridePresetForm.controls.id">
          <select formControlName="id" data-test-id="preset-select">
            @for (preset of customPresets; track preset) {
              <option [value]="preset.id">{{ preset.name || 'Unnamed Preset' }}</option>
            }
          </select>
          <label>Choose Preset...</label>
        </app-input-field>
      }
      <button
        appButton
        name="confirm-update"
        location="save-gallery-prset-dialog"
        data-test-id="update-preset-confirm"
        color="primary"
        height="3"
        shape="round"
        class="cta"
        size="3"
        weight="bold"
        spacing="full"
      >
        <span [class.hidden-text]="loading">Update Preset</span>
        @if (loading) {
          <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
        }
      </button>
    </form>
  }
</div>
